<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style lang="scss">
  @import "~@/scss/main.scss";
</style>

<script>
import clientConfig from '/src/config/client';
import { useIdle } from '@vueuse/core';

const IDLE_TIMEOUT = 60 * 1000 * 15;
const { idle } = useIdle(IDLE_TIMEOUT);

export default {
	name: 'App',
	components: {},
	data() {
		return { idle };	
	},
	mounted() {
		// Clear state and go home on refresh
		this.$store.commit("setDefaults");
		// eslint-disable-next-line no-unused-vars
		this.$router.push('/').catch(_ => {});

		if(clientConfig.analytics.customanalytics) {
			let customScript = document.createElement('script');
			customScript.setAttribute('src', clientConfig.analytics.customanalytics.customScriptURL);
			document.head.appendChild(customScript);

			let dataLayerScript = document.createElement('script');
			dataLayerScript.innerHTML = clientConfig.analytics.customanalytics.dataLayer;
			document.head.appendChild(dataLayerScript);
			// window.digitalData = clientConfig.analytics.customanalytics.dataLayer;
		}
	},
	created () {
    window.addEventListener('beforeunload', this.beforeWindowUnload);
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.beforeWindowUnload);
  },
	watch: {
		idle: function (newIdle) {
			if (newIdle) { // 15 mins of inactivity will clear state
				this.$store.commit("setDefaults");
				this.$store.commit("updateAcceptedDisclaimer", false);
				if(this.$route.path !== '/') {
					this.$router.push('/');
				}
			}
		}
	},
	methods: {
		// Refresh confirmation
		beforeWindowUnload (e) {
        e.preventDefault();
        e.returnValue = '';
    }
	}
}
</script>